export default __webpack_public_path__ + "a477976b40b6578e443f9a9e0779b1a5.ttf";